import { AppShell } from './AppShell';
import TodayIcon from '@mui/icons-material/Today';
import EventNoteIcon from '@mui/icons-material/EventNote';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MedicationIcon from '@mui/icons-material/Medication';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ScienceIcon from '@mui/icons-material/Science';
import ForwardIcon from '@mui/icons-material/Forward';
import VerifiedIcon from '@mui/icons-material/Verified';
import BadgeIcon from '@mui/icons-material/Badge';
import ScheduleIcon from '@mui/icons-material/Schedule';
import RouteIcon from '@mui/icons-material/Route';
import SmartToyIcon from '@mui/icons-material/SmartToy';

export function ClinicianLayout() {
  return (
    <AppShell noHeader
      brand={{
        title: 'MyBooking Clinical',
        subtitle: 'Clinician console',
        href: '/clinician',
      }}
      sections={[
        {
          items: [
            { to: '/clinician',              label: 'Today',           icon: <TodayIcon />, exact: true },
            { to: '/clinician/appointments', label: 'Appointments',    icon: <EventNoteIcon /> },
            { to: '/clinician/availability', label: 'Availability',    icon: <ScheduleIcon /> },
          ],
        },
        {
          heading: 'Documents',
          items: [
            { to: '/clinician/encounters',    label: 'Encounters',     icon: <EditNoteIcon /> },
            { to: '/clinician/prescriptions', label: 'Prescriptions',  icon: <MedicationIcon /> },
            { to: '/clinician/sick-notes',    label: 'Sick notes',     icon: <LocalHospitalIcon /> },
            { to: '/clinician/lab-orders',    label: 'Lab orders',     icon: <ScienceIcon /> },
            { to: '/clinician/referrals',     label: 'Referrals',      icon: <ForwardIcon /> },
          ],
        },
        {
          heading: 'Care & AI',
          items: [
            { to: '/clinician/pathways', label: 'Care pathways', icon: <RouteIcon /> },
            { to: '/clinician/ai-log',   label: 'AI log',        icon: <SmartToyIcon /> },
          ],
        },
        {
          heading: 'Profile',
          items: [
            { to: '/clinician/credentials', label: 'Credentials', icon: <VerifiedIcon /> },
            { to: '/clinician/me',          label: 'Profile',     icon: <BadgeIcon /> },
          ],
        },
      ]}
    />
  );
}